import { GRID } from '../tokens/size';

export const enecoImageTokens = {
  imageSplitviewBorderRadii: `${GRID * 4}px`,
};
